import React, { useEffect } from "react";
import { Routes, Route, BrowserRouter, Navigate, Outlet } from "react-router-dom";
import Home from "./pages/Home";
import Draft from "./pages/Draft";
import PostViewing from "./pages/PostViewing";
import Dashboard from "./pages/Dashboard";
import AuthComponent from "./components/auth/AuthComponent";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import "./App.css";
import { clarity } from 'react-microsoft-clarity';
import SocialCallback from "./pages/SocialCallback";
import SessionExpiredModal from "./components/common/SessionExpiredModal";

if (process.env.REACT_APP_CLARITY_ID) {
  clarity.init(process.env.REACT_APP_CLARITY_ID);
}

const isMockAuth = process.env.REACT_APP_MOCK_AUTH === "true";

const MockRoute = () => <Outlet />;

function App() {
  return (
    <BrowserRouter>
      <SessionExpiredModal />
      <Routes>
        <Route path="/" element={isMockAuth ? <Navigate to="/create" replace /> : <AuthComponent />} />
        <Route path="/redirect" element={<AuthComponent />} />
        <Route path="/confirmation" element={<SocialCallback />} />
        <Route element={isMockAuth ? <MockRoute /> : <ProtectedRoute />}>
          <Route path="/create" element={<Home />} />
          <Route path="/draft" element={<Draft />} />
          <Route path="/viewing" element={<PostViewing />} />
          <Route path="/dashboard" element={<Dashboard />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;